/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Timecodes_DescriptionInputs */



/**
* | output |
* | --- |
* | "Copy timecodes from one group to another" |
*
* @param {Copy_Timecodes_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_timecodes_description = /** @type {((inputs?: Copy_Timecodes_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Timecodes_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier les timecodes d’un groupe à un autre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timecodes von einer Gruppe in eine andere kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia i codici temporali da un gruppo all'altro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Копирование временных меток из одной группы в другую.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar códigos de tiempo de un grupo a otro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将时间码从一个组复制到另一个组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("あるグループから別のグループにタイムコードをコピーする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक समूह से दूसरे समूह में टाइमकोड कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar códigos de tempo de um grupo para outro.")
	return /** @type {LocalizedString} */ ("Copy timecodes from one group to another")
});